import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, FormLabel } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledCategoryTagsCardContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.background.tableOdd};
  padding: 1.2rem 1.6rem 1.2rem 1.6rem;
  border-radius: ${({ theme }) => theme.radius.small};
  border: 0.1rem solid ${({ theme }) => theme.colors.background.tableOdd};
  transition: all 0.1s ease-in-out;
  margin-bottom: 1rem;

  &&:hover {
    box-shadow: 0px 7.9px 26px 0px rgba(0, 0, 0, 0.15);
    background-color: ${({ theme }) => theme.colors.background.lighter};
    border: 0.1rem solid ${({ theme }) => theme.colors.border.light};
  }
`;

export const StyledCategoryLabel = styled.h5`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.main};
  line-height: 1.9rem;
  margin: 0;
`;

export const StyledAddButton = styled(Button)`
  && {
    background-color: ${({ theme }) => theme.colors.background.lighter};
    &&:hover {
      background-color: ${({ theme }) => theme.colors.grey[200]};
      color: ${({ theme }) => theme.colors.info.secondary};
    }
  }
`;

export const StyledHeaderWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;

export const StyledInfoContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.8rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
`;

export const StyledTag = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.tiny};
  padding-left: 1rem;
  padding-right: 1rem;
  border-radius: ${({ theme }) => theme.radius.huge};
`;

export const StyledLine = styled.div`
  height: 0.1rem;
  background-color: ${({ theme }) => theme.colors.border.dropdown};
  margin-bottom: 1rem;
`;

export const StyledRadioWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
`;

export const StyledFormLabel = styled(FormLabel)`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
`;

export const StyledSourceTag = styled(StyledTag)`
  background-color: rgba(235, 0, 55, 0.2);
  color: ${({ theme }) => theme.colors.error.main};
`;

export const StyledIdTag = styled(StyledTag)`
  color: ${({ theme }) => theme.colors.info.main};
  background-color: ${({ theme }) => theme.colors.info.light};
`;

export const StyledRemoveButton = styled(Button)`
  && {
    background-color: ${({ theme }) => theme.colors.background.lighter};
    &&:hover {
      background-color: ${({ theme }) => theme.colors.grey[200]};
      color: ${({ theme }) => theme.colors.error.main};
    }
  }
`;

export const StyledTrashIcon = styled(FontAwesomeIcon)`
  && {
    height: 1.9rem;
    width: 1.2rem;
  }
`;
